import React, { PureComponent } from 'react';
import { Table } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { Shapes } from '../../models/entities';
import PaymentSortableHeader from '../../containers/tables/PaymentSortableHeader';
import SelectableRow from './SelectableRow';

class PaymentTable extends PureComponent {
  constructor(props) {
    super(props);
    this.getAccountData = this.getAccountData.bind(this);
  }

  getAccountData(payment) {
    const {
      accountDataById, paymentDataById,
    } = this.props;
    return accountDataById[paymentDataById[payment.paymentData].accountData];
  }

  render() {
    const {
      payments, clientsById, terminalsById, onSelectChange, selectedId,
    } = this.props;

    const timeZone = ' ' + new Date().toLocaleDateString(undefined, {day:'2-digit',timeZoneName: 'short' }).substring(4);
    
    return (
      <Table striped bordered responsive="lg" size="sm">
        <thead>
          <tr>
            <PaymentSortableHeader fieldName="id">#</PaymentSortableHeader>
            <PaymentSortableHeader fieldName="paymentData.accountData.accountNumber">Account</PaymentSortableHeader>
            <PaymentSortableHeader fieldName="terminal">Terminal</PaymentSortableHeader>
            <PaymentSortableHeader disabled fieldName="paymentData.accountData.client">Client</PaymentSortableHeader>
            <PaymentSortableHeader fieldName="paymentAmount">Amount</PaymentSortableHeader>
            <PaymentSortableHeader fieldName="paymentData.accountData.lastName">Last Name</PaymentSortableHeader>
            <PaymentSortableHeader fieldName="paymentType">Type</PaymentSortableHeader>
            <PaymentSortableHeader fieldName="tpsPaymentReceipt">TPS Receipt</PaymentSortableHeader>
            <PaymentSortableHeader fieldName="processorTransactionId">Processor ID</PaymentSortableHeader>
            <PaymentSortableHeader fieldName="dateTime">Timestamp</PaymentSortableHeader>
          </tr>
        </thead>
        <tbody>
          {payments.length > 0
            ? payments.map((payment) => (
              <SelectableRow
                onSelectChange={onSelectChange}
                selected={payment.id === selectedId}
                rowId={payment.id}
                key={payment.id}
              >
                <td>{payment.id}</td>
                <td>{this.getAccountData(payment).accountNumber}</td>
                <td>{terminalsById[payment.terminal].name}</td>
                <td>{clientsById[this.getAccountData(payment).client].name}</td>
                <td>{payment.paymentAmount}</td>
                <td>{this.getAccountData(payment).lastName}</td>
                <td>{payment.paymentType}</td>
                <td>{payment.tpsPaymentReceipt}</td>
                <td>{payment.processorTransactionId || '-'}</td>
                <td>{(new Date(payment.dateTime + 'z')).toLocaleString() + timeZone}</td>
              </SelectableRow>
            )) : (
              <tr>
                <td colSpan={10}>No records.</td>
              </tr>
            )}
        </tbody>
      </Table>
    );
  }
}

PaymentTable.propTypes = {
  payments: PropTypes.arrayOf(Shapes.PAYMENT),
  accountDataById: PropTypes.objectOf(PropTypes.shape({
    id: PropTypes.number,
    accountData: Shapes.ACCOUNT_DATA,
  })),
  paymentDataById: PropTypes.objectOf(PropTypes.shape({
    id: PropTypes.number,
    paymentData: Shapes.PAYMENT_DATA,
  })),
  clientsById: PropTypes.objectOf(PropTypes.shape({
    id: PropTypes.number,
    client: Shapes.CLIENT,
  })),
  terminalsById: PropTypes.objectOf(PropTypes.shape({
    id: PropTypes.number,
    terminal: Shapes.TERMINAL,
  })),
  selectedId: PropTypes.number,
  onSelectChange: PropTypes.func.isRequired,
};

PaymentTable.defaultProps = {
  payments: [],
  accountDataById: {},
  paymentDataById: {},
  clientsById: {},
  terminalsById: {},
  selectedId: undefined,
};

export default PaymentTable;
